import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import validator from "validator";
import { getMessage } from "CONFIG/i18n";
import { validateMobileNumber } from "../../Utils/regexValidations";
import { separatePhoneNumberAndEmails, getPhoneNumberWithCountryCode, setSMSMessage, checkInvite } from "UTILS/Utility";
import { USER_ROLES } from "UTILS/Constants";

import "./AddInvitee.less";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

import { organisationAction } from "CONFIG/ActionFactory";

class AddInvitee extends Component {

  constructor(props) {
    super(props);
    this.isIE = /*@cc_on!@*/false || !!document.documentMode;
  }
  state = {
    invitees: "",
    errorMessage: "",
    isCheckInvite: false,
    isInviteForce: false,
    checkInviteMessage: "",
    checkInviteList: [],
  };
  toggle = () => {
    this.props.addInviteeManualHandle();
  };

  componentDidMount() {
    setSMSMessage(this, ["MANUAL_ENTRY_NON_SMS", "VALID_EMAIL_PHONE_NON_SMS"]);

    if (this.props.role != USER_ROLES.USER) {
      organisationAction.getCustomerSmsSendNum().then(
        response => {
          const maxSmsSend = response.data.data.maxSmsSend;
          const smsSendToday = response.data.data.smsSendInfo[0].sms_count;
          const smsSendThisMonth = response.data.data.smsSendInfo[1].sms_count;

          if (this.props.isSMSEnabled && maxSmsSend != 0 && (smsSendToday + smsSendThisMonth >= maxSmsSend)) {
            this.setState({maxSmsSendMessageError: getMessage("ERR_MSG_MAX_SMS_SEND")});
          }
        }
      )
    }

  }

  isValidEmailsOrPhone = (name, array) => {
    for (let i = 0; i < array.length; i++) {
      if (name === "email") {
        if(!validator.isEmail(array[i]))
          return false;
      } else if (!validateMobileNumber(array[i])) {
        return false;      
      }
    }
    return true;
  };

  getFilteredArrayOfEmailOrPhoneNumbers = value => {
    return value.split(/[,;]/g).filter(el => el !== "");
  };
  createInviteeObjectsArray = (value, array) => {
    let result = [];
    for (let i = 0; i < array.length; i++) {
      let obj = {};
      if (value === "phone") {
        obj[value] = getPhoneNumberWithCountryCode(array[i]);
      } else {
        (obj[value] = array[i]);
      }
      result.push(obj);
    }
    return result;
  };
  getInviteesArray = (emails, numbers) => {
    let emailsArray = this.createInviteeObjectsArray("email", emails);
    let NumbersArray = this.createInviteeObjectsArray("phone", numbers);
    return [...emailsArray, ...NumbersArray];
  };

  handleSendClick = () => {
    if (this.props.isSMSEnabled) {

      var separators = [",", ";"];
      let arrayOfInvitees = this.state.invitees.split(
        new RegExp(separators.join("|"), "g")
      );
      let{ arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);
      
      this.setState({maxSmsSendMessageError: ""});
      new Promise((resolve, reject) => {
        organisationAction.getCustomerSmsSendNum().then(
          response => {
            const maxSmsSend = response.data.data.maxSmsSend;
            const smsSendToday = response.data.data.smsSendInfo[0].sms_count;
            const smsSendThisMonth = response.data.data.smsSendInfo[1].sms_count;
            
            if (arrayOfPhone.length != 0 && arrayOfPhone[0] != '') {
              if (this.props.isSMSEnabled && maxSmsSend!=0 && (arrayOfPhone.length + smsSendToday + smsSendThisMonth > maxSmsSend)) {
                this.setState({maxSmsSendMessageError: getMessage("ERR_MSG_MAX_SMS_SEND")});
                let addButton = document.getElementById("addButton");
                addButton.disabled = false;  
              } else {
                this.handleSendClickNonSMS();
              }
            } else {
              this.handleSendClickNonSMS();
            }
            resolve();
          },
          error => {
            reject(error);
          }
        );
      });
    } else {
      this.handleSendClickNonSMS();
    }
  }

  handleSendClickNonSMS = async() => {
    if (this.state.invitees) {
      let arrayOfInvitees = this.getFilteredArrayOfEmailOrPhoneNumbers(this.state.invitees)
      let { arrayOfEmails,arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);
      //console.log(arrayOfInvitees,emails,numbers)
      let isValidEmails = this.isValidEmailsOrPhone("email", arrayOfEmails);
      let isValidNumbers = this.isValidEmailsOrPhone("phone", arrayOfPhone);
      if (arrayOfEmails.length !== 0 && !isValidEmails) {
        this.setState({
          errorMessage: getMessage("VALID_EMAIL")
        });
        return;
      }

      if ((! this.props.isSMSEnabled) && (arrayOfPhone.length != 0)) {
        this.setState({
          inviteeInvalid: true,
          errorMessage: getMessage("ERR_MSG_UNABLE_SMS"),
        });
        return false;
      }

      if (arrayOfPhone.length !== 0 && !isValidNumbers) {
        this.setState({
          errorMessage: getMessage("VALID_PHONE")
        });
        return;
      }
      let invitees = this.getInviteesArray(arrayOfEmails, arrayOfPhone);

      if (!this.state.isInviteForce) {
        const resultCheckInvite = await checkInvite(invitees);
        if (resultCheckInvite) {
          this.setState({
            isCheckInvite: true,
            errorMessage: getMessage("INVITATION_CHECK_ERROR"),
            checkInviteList: resultCheckInvite
          });
          return;
        }
      }

      this.props.handleSendClick(invitees, true);
      this.setState({
        invitees: "",
        errorMessage: "",
        isCheckInvite: false,
        isInviteForce: false,
        checkInviteMessage: "",
        checkInviteList: [],
      });
    } else {
      this.setState({
        errorMessage: getMessage(this.state.validEmailPhone)
      });
    }
  };
  handleInputChange = name => event => {
    this.setState({
      invitees: event.target.value.replace(" ", "").trim(),
      errorMessage: "",
      isCheckInvite: false,
      isInviteForce: false,
      checkInviteMessage: "",
      checkInviteList: [],
    });
  };
  
  clearState=()=>{
    this.setState({
      invitees: "",
      errorMessage: "",
      isCheckInvite: false,
      isInviteForce: false,
      checkInviteMessage: "",
      checkInviteList: [],
    })
  }

  //Handled proceed on enter key press
  enterPressed = event => {
    var code = event.keyCode || event.which;
    //console.log('keyPress: ', event, code, event.target.value.trim());
    if (code === 13) {
      event.preventDefault();
      this.handleSendClick();
    }
  };

  setFocusForIE = () => {
    this.isIE && setTimeout(() => {
      document.getElementById("addButton").focus();
    }, 300);
  }
  
  detectEsc = (event) => {
    var kDown = event.keyCode || event.which;
    if (kDown === 27) {
      event.preventDefault();
      this.toggle();
    }
  }

  showCheckInvite = () => {
    let checkInviteMessage = [];
    this.state.checkInviteList.forEach((participant, index) => {
      const email = participant.split('@');
      checkInviteMessage.push(<>{email[0] + "@"}<span className="checkInvite">{email[1]}</span></>);
      if (this.state.checkInviteList.length - 1 > index) {
        checkInviteMessage.push(<>{", "}</>);
      }
    })
    return (
      <>{checkInviteMessage}</>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="modal-md modalContainer modal-wrapper"
        xs="8"
        onOpened={this.setFocusForIE}
        onKeyDown={this.detectEsc}
        onClosed={this.clearState}
        autoFocus={false}
      >
        <ModalHeader toggle={this.toggle} className="popupHeader addMemberHeader">
          {getMessage(this.state.manualEntryMsg)}
        </ModalHeader>
        <ModalBody className="popupBody">
          <div className="AddInvitee">
            <section className="bgColor ">
              <Container className="noPadding">
                <Row>
                  <Col
                    lg="12"
                    md="12"
                    xs="12"
                    className="inputFormAddInvitee"
                  >
                    <div className="inputForm">
                      <Col>
                        <Form>
                          <FormGroup>
                            <Input
                              type="text"
                              maxLength="100"
                              className="inputFormControl"
                              onChange={this.handleInputChange()}
                              value={this.state.invitees}
                              placeholder={getMessage("INVITE_INPUT_PLACEHOLDER")}
                              onKeyPress={this.enterPressed}
                              autoFocus={!this.isIE}
                            />
                          </FormGroup>
                        </Form>
                      </Col>
                      {(!this.state.isCheckInvite) ?
                        <><Col className="addBtn text-center justify-content-center">
                          <Button
                            className="btnAdd whiteOnClick w-25"
                            onClick={this.handleSendClick}
                            id="addButton"
                          >
                            {getMessage("SEND")}
                          </Button>
                        </Col>
                        <Col className="errorsLabel text-center autoHeight">
                          {this.state.errorMessage}
                          {this.state.maxSmsSendMessageError}
                        </Col></> :
                        <>
                          <Col className="errorsLabel text-center autoHeight">
                            {this.state.errorMessage}
                          </Col>
                          <Col className="errorsLabel text-center autoHeight">
                            {this.showCheckInvite()}
                          </Col>
                          <Col className="text-center justify-content-center">
                            <Button
                              className="btnAdd whiteOnClick w-25"
                              onClick={() => {
                                this.state.isInviteForce = this.state.isCheckInvite ? true : false;
                                this.handleSendClick();
                              }}
                              id="addButton"
                            >
                              {getMessage("SEND")}
                            </Button>
                          </Col>
                        </>
                      }
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
export default modalScrollBar(AddInvitee);
